import {Props} from './model';
import {TouchableOpacity, View} from 'react-native';
import * as React from 'react';
import {useStyles} from '../../../../hooks/styles';
import {Text} from '../../../text';
import {themeSelector} from '../../../../../redux/selectors/runtime/theme';
import {useSelector} from 'react-redux';

export default ({label, labelStyle, icon, iconWidth = 18, iconHeight = 18, onPress, testID}: Props) => {
  const themeSettings = useSelector(themeSelector());

  const styles = useStyles(({theme}) => ({
    container: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    icon: {
      marginRight: label ? 8 : 0,
      marginBottom: 0,
      color: theme.header.iconsColor,
    },
  }));
  const dataSetLink = {
    dataSet: {
      class: 'icon-link',
    },
  };
  const Icon = icon;

  return (
    <TouchableOpacity testID={testID} {...dataSetLink} onPress={onPress} style={styles.container}>
      {Icon && !themeSettings.visuallyImpaired && (
        <View style={styles.icon}>
          <Icon width={iconWidth} height={iconHeight} color={styles.icon.color} />
        </View>
      )}
      {label ? (
        <Text type='body' style={[labelStyle]}>
          {label}
        </Text>
      ) : null}
    </TouchableOpacity>
  );
};
